import styleFn from '../util'

const colsize = styleFn({
  propName: 'size',
  cssProp: ['flex-basis', 'max-width'],
  systemProp: 'colsizes'
})

export default colsize
